import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    padding: '20px',
    boxSizing: 'border-box',
  },
  spinner: {
    color: '#00B4AF',
    [theme.breakpoints.down('xs')]: {
      width: '50px !important',
      height: '50px !important',
    },
  },
  text: {
    marginTop: 20,
    fontSize: 16,
    color: '#2c3034',
    fontWeight: '500',
    textAlign: 'center',
    padding: '0 15px',
    maxWidth: '90%',
    wordWrap: 'break-word',
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
      marginTop: 15,
    },
  }
}));

const LoadingScreen = ({ message = "Loading..." }) => {
  const classes = useStyles();
  
  return (
    <div className={classes.container}>
      <CircularProgress size={60} className={classes.spinner} />
      <div className={classes.text}>{message}</div>
    </div>
  );
};

export default LoadingScreen;


